import { Grid } from '@mui/material';
import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  selectedValue: number;
  className?: string;
}

function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, selectedValue, index, className } = props;

  return (
    <Grid container alignItems='center' justifyContent='center' spacing={3} className={className}>
      {selectedValue === index && children}
    </Grid>
  );
}

export default TabPanel;
